// PDF Export utility for stories
// Note: This is a simple implementation. For production, consider using jsPDF or pdfmake

export const exportStoryAsPDF = async (story) => {
  try {
    // Create a simple HTML document for the story
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${story.title}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap');
    body {
      font-family: 'Patrick Hand', cursive;
      max-width: 800px;
      margin: 40px auto;
      padding: 20px;
      line-height: 1.8;
      color: #2d3748;
    }
    h1 {
      font-size: 32px;
      color: #9d9cd6;
      text-align: center;
      margin-bottom: 30px;
      border-bottom: 3px solid #9d9cd6;
      padding-bottom: 15px;
    }
    .story-content {
      font-size: 18px;
      text-align: justify;
      margin-bottom: 30px;
    }
    .story-image {
      max-width: 100%;
      height: auto;
      margin: 20px 0;
      border-radius: 12px;
      border: 3px solid #9d9cd6;
    }
    .section-title {
      font-size: 24px;
      color: #9d9cd6;
      margin-top: 30px;
      margin-bottom: 15px;
      border-left: 5px solid #9d9cd6;
      padding-left: 15px;
    }
    .vocabulary-list, .prompts-list, .phonics-list {
      list-style: none;
      padding: 0;
    }
    .vocabulary-list li, .prompts-list li, .phonics-list li {
      padding: 8px 0;
      border-bottom: 1px solid #e5e7eb;
    }
    .vocabulary-list li strong {
      color: #9d9cd6;
    }
    .moral {
      background: #f7d794;
      padding: 15px;
      border-radius: 12px;
      border: 3px solid #9d9cd6;
      font-size: 16px;
      margin: 20px 0;
    }
    @media print {
      body { margin: 0; padding: 20px; }
      .story-image { page-break-inside: avoid; }
    }
  </style>
</head>
<body>
  <h1>${story.title}</h1>
  
  ${story.images && story.images.length > 0 ? 
    story.images.map(img => `<img src="data:image/png;base64,${img}" class="story-image" alt="Story illustration" />`).join('') 
    : ''}
  
  <div class="story-content">
    ${story.content.split('\n').map(para => `<p>${para}</p>`).join('')}
  </div>
  
  ${story.moral ? `
  <div class="moral">
    <strong>Moral:</strong> ${story.moral}
  </div>
  ` : ''}
  
  ${story.vocabulary && story.vocabulary.length > 0 ? `
  <div class="section-title">Vocabulary Words</div>
  <ul class="vocabulary-list">
    ${story.vocabulary.map(item => {
      if (typeof item === 'object' && item.word && item.definition) {
        return `<li><strong>${item.word}:</strong> ${item.definition}</li>`;
      } else if (typeof item === 'string') {
        return `<li>${item}</li>`;
      }
      return '';
    }).join('')}
  </ul>
  ` : ''}
  
  ${story.phonics && story.phonics.length > 0 ? `
  <div class="section-title">Phonics Practice</div>
  <ul class="phonics-list">
    ${story.phonics.map(phonics => `<li>${phonics}</li>`).join('')}
  </ul>
  ` : ''}
  
  ${story.parent_prompts && story.parent_prompts.length > 0 ? `
  <div class="section-title">Discussion Questions</div>
  <ul class="prompts-list">
    ${story.parent_prompts.map(prompt => `<li>${prompt}</li>`).join('')}
  </ul>
  ` : ''}
  
  <div style="margin-top: 50px; text-align: center; color: #718096; font-size: 14px;">
    <p>Created with StoryTime Studio</p>
    <p>Reading Level: ${story.reading_level} years</p>
  </div>
</body>
</html>
    `;

    // Create a blob from the HTML content
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);

    // Create a temporary link and trigger download
    const a = document.createElement('a');
    a.href = url;
    a.download = `${story.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    // Open in new window for printing
    const printWindow = window.open(url);
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        setTimeout(() => {
          printWindow.print();
        }, 250);
      });
    }

    return true;
  } catch (error) {
    console.error('PDF export error:', error);
    throw error;
  }
};

export const shareStory = async (story) => {
  try {
    if (navigator.share) {
      await navigator.share({
        title: story.title,
        text: `Check out this bedtime story: ${story.title}\n\n${story.summary || story.content.substring(0, 200)}...`,
        url: window.location.href
      });
      return true;
    } else {
      // Fallback: Copy to clipboard
      const shareText = `${story.title}\n\n${story.summary || story.content.substring(0, 200)}...\n\nCreated with StoryTime Studio`;
      await navigator.clipboard.writeText(shareText);
      return 'copied';
    }
  } catch (error) {
    console.error('Share error:', error);
    throw error;
  }
};
